import { Form, Input } from "decorator-form";
import { Entity, Field } from "typegraph";

import EntitySelect from "common/form/fields/entitySelect/EntitySelect";

@Entity({one: 'kbCategory_one', many: 'kbCategory_many'})
class Category {
	@Field() public id: any;
	@Field() public guid: string;
	@Field() public name: string;
}

const categorySelect = EntitySelect.registered({
	entity: Category,
	type: 'one',
	getValue: (c) => c.guid,
	getDefaultValueParams: (categoryGuid) => ({guid: categoryGuid})
}, 'string');

@Form({title: "Category Details Panel"})
export default class CategoryDetailsPanelConfig {

	@Input({type: categorySelect, title: "Default Category"})
	public categoryGuid: string;

}



// WEBPACK FOOTER //
// ./src/panels/kb/config/CategoryDetailsPanelConfig.tsx